import Definition from '@client/config/definition';
import { unit as mathUnit } from 'mathjs';
import { getActivityIndex } from '../utils/getActivityIndex';
import { getActivityName } from '../utils/getActivityName';
import unitHelper from '@client/helper/unit';
import { i18n } from '@client/helper/i18n';
import { isBikeCategoryByName, isPoolSwimCategory } from '@client/helper/sport';
import { distanceStatistic, timeStatistic, statisticAvg, statisticMax, statisticSum } from '../utils/columnDefinitionUtil';
import { h } from 'vue';
import { EMPTY_TEXT, EMPTY_TEXT_SINGLE } from '@client/config/other';
import * as corosSportConfig from '@coros/sport-config';

import { IconDown, IconRight } from '@arco-design/web-vue/es/icon';

import { SportMode } from '@mytypes/activity-detail/ApiModel/SportMode';
import { isLapExpandable } from '../hooks/swimLapData';
import { LapItem } from '@mytypes/activity-detail/LapList';
import { getSwimIndexAndName } from '../utils/getIndexNew/swim';
import { getStrengthActionName } from './sport-specific-column-config/strength-colums';
import type { BottomTableColumnDefine, ColumnDefinitionInject } from './types';
import { getClimbColumns } from './sport-specific-column-config/climb-columns';
import { getIndexNew } from '../utils/getIndexNew/getIndexNew';
import { lapListTypeIsLap, newLapListType } from '../hooks/useLapSelectValue';
import { lapTypeOptions } from '../hooks/useLapTypeOptions';
import { getClimbStairsColumn } from '../../../../personal/activities/consts/sport-specific-column/climb-stairs-column';

import { useActivityDetail } from '../../../hooks/useActivityDetail';
import { TableData } from '@arco-design/web-vue';
import { getSkiTouringIndex } from '../utils/getIndexNew/Ski_Touring';

const { isIndoorClimbOrBoulderingTrainingSportName } = corosSportConfig.sport.climb;

const { temperatureUnitType, isInterval } = useActivityDetail();
const { t } = i18n;
// 累计爬升
const CUMULATIVE_CLIMB = 'cumulativeClimb';

// 公制key
const METRIC_UNITS = Definition.METRIC_UNITS;
// 英制key
const IMPERIAL_UNITS = Definition.IMPERIAL_UNITS;
// SALT 常量

// 所有列的定义
export function columnsDefinition(inject: ColumnDefinitionInject) {
  const { summary, unitType, sportType, sportName, listData, hasPostureTest, setExpandLapindex, currentExpandLapIndex, isNewLapStyle } =
    inject;

  // 温度单位temperatureUnit特殊逻辑
  const finalTemperatureUnitType = temperatureUnitType.value;

  const isPoolSwim = isPoolSwimCategory(sportType.value);
  const isBikeSport = isBikeCategoryByName(sportName);
  const sportMode = summary.sportMode;
  const speedUnit = summary.speedUnit;
  // 训练组合
  const isProgram = !!summary.programId;
  const { isAllDistanceRef } = inject;
  console.log(
    `isProgram`,
    isProgram,
    'isInterval',
    sportMode === SportMode.INTERVAL,
    'isRunTest',
    summary.isRunTest,
    'sportType',
    sportType.value,
    sportName,
    'finalTemperatureUnitType',
    finalTemperatureUnitType
  );

  const statisticHtml = (value = '', unit = '') => {
    return [value, unit];
  };

  const Left_Gap: BottomTableColumnDefine = {
    minWidth: summary.programId ? 8 : 112,
    status: true,
    canSetStatus: false,
    fixed: 'left',
    // 最快标识
    render({ record: rowData, rowIndex: index }: { record: LapItem; rowIndex: number }) {
      const result = [];

      // 泳池游泳特殊处理
      if (isPoolSwim) {
        // console.log(`rowData`, rowData.uniqueId, rowData.mode, rowData.noParentData, rowData.distance, rowData.swimStyle);
        if (
          lapListTypeIsLap.value &&
          lapTypeOptions.value.length > 1 &&
          !rowData.x_isExpandSub &&
          isLapExpandable(rowData) &&
          // 圈数据为0，则该圈不可展开
          rowData.distance > 0
        ) {
          // 恢复
          const modeIsOk =
            (isProgram || (!isProgram && sportMode === SportMode.INTERVAL)) &&
            (Definition.isExerciseMode(rowData.mode) || Definition.isWarmupMode(rowData.mode) || Definition.isRelaxMode(rowData.mode));

          if (modeIsOk) {
            result.push(
              h(currentExpandLapIndex.value === rowData.lapIndex ? IconDown : IconRight, {
                class: `p-4 cursor-pointer mr-10`,
                style: {
                  marginLeft: isProgram ? '16px' : '0'
                },
                onClick: (event) => {
                  event.stopPropagation();
                  setExpandLapindex(rowData.lapIndex);
                }
              })
            );
          }
        }
        if (!rowData.x_isExpandSub && !rowData.x_isParentData && rowData.isFastest) {
          result.push(h('span', { class: 'fastest-tips' }, t('H6008')));
        }

        return result;
      }

      // 以下是其他运动

      if (rowData.isFastest)
        result.push(h('span', { class: 'fastest-tips' }, t(isIndoorClimbOrBoulderingTrainingSportName(sportName) ? 'SQ7003' : 'H6008')));

      // 2024年11月18日 去掉色块
      // if (summary.programId) {
      //   result.push(
      //     h(
      //       'div',
      //       {
      //         class: 'color-rect',
      //         style: {
      //           background: inject.getColorRectBg(rowData, index)
      //         }
      //       },
      //       ' '
      //     )
      //   );
      // }

      return result;
    }
  };
  // 圈数/趟数
  const Laps_Lengths: BottomTableColumnDefine = {
    title: (() => {
      if (newLapListType.value === 1 || ['Ski', 'Snowboard'].includes(sportName)) {
        return t('H1052');
      }

      return t('H6006');
    })(),
    status: true,
    canSetStatus: false,
    showTips: true,
    render({ record: rowData, rowIndex: index }) {
      // 泳池游泳特殊处理
      if (isPoolSwim) {
        const { activityIndex, activityName } = getSwimIndexAndName({
          data: rowData,
          isProgram,
          sportName,
          sportMode
        });

        const { x_isExpandSub, x_isParentData } = rowData;

        let val = `${activityName ? t(activityName) : ''}`;
        let indexResult = '';
        if (!((lapListTypeIsLap.value && x_isExpandSub) || (!lapListTypeIsLap.value && x_isParentData))) {
          indexResult = `${activityIndex}`;
        }
        if (val === '' && indexResult === '') {
          val = EMPTY_TEXT;
        }
        return [h('span', { class: 'activity-index' }, indexResult), h('span', { class: 'activity-name' }, val)];
      }

      const activityIndex = getIndexNew({
        data: rowData,
        isProgram,
        sportMode,
        sportName
      });
      const activityName = getActivityName(
        {
          data: rowData,
          index,
          isProgram,
          sportName,
          sportMode
        },
        { isAllDistanceRef, hasPostureTest }
      );

      const isOpacity =
        Definition.isRecoveryMode(rowData.mode) ||
        (sportMode === SportMode.INTERVAL && lapListTypeIsLap.value && Definition.isRecoveryMode(rowData.mode));

      // 部分逻辑下展示旧样式
      if (!isNewLapStyle.value) {
        // 以下是其他运动
        const splitLabel = activityIndex && activityName ? ' ' : '';
        const val = `${activityIndex}${splitLabel}${activityName ? t(activityName) : ''}`;

        if (isOpacity) {
          return h('div', { style: { opacity: 0.5 } }, val);
        }

        return val;
      }

      return [
        h('span', { class: 'activity-index' }, activityIndex),
        h('span', { class: 'activity-name', style: { opacity: isOpacity ? 0.5 : 1 } }, activityName ? t(activityName) : '')
      ];
    },
    useIt() {
      // 室内攀岩、抱石类型没有关联训练的，不显示【圈数】
      if (isIndoorClimbOrBoulderingTrainingSportName(sportName)) {
        return isProgram;
      }
      return true;
    }
  };

  // 运动特有列
  let sportSpecificColumns: Record<string, BottomTableColumnDefine> = {};
  // 泳池游泳特有列
  if (isPoolSwim) {
    sportSpecificColumns = {
      StartTime: {
        minWidth: 50,
        title: '开始时间',
        status: true,
        canSetStatus: false,
        render({ record: rowData }) {
          return rowData.startTimestamp.toString().slice(5);
        }
      },
      EndTime: {
        minWidth: 50,
        title: '结束时间',
        status: true,
        canSetStatus: false,
        render({ record: rowData }) {
          return rowData.endTimestamp.toString().slice(5);
        }
      }
    };
  }
  // 健身特有列
  else if (sportName === 'Strength') {
    sportSpecificColumns = getStrengthActionName({
      isProgram,
      sportName,
      sportMode,
      listData,
      isAllDistanceRef
    });
  }
  // 室内攀岩、抱石特有列
  else if (isIndoorClimbOrBoulderingTrainingSportName(sportName)) {
    const { indoorClimbOrBoulderingColumns } = getClimbColumns({
      listData,
      isProgram,
      unitType,
      sportName,
      sportMode,
      isAllDistanceRef
    });
    sportSpecificColumns = indoorClimbOrBoulderingColumns;
  }
  // 户外攀岩特有列
  else if (sportName === 'Climb') {
    const { climbingColumns } = getClimbColumns({
      listData,
      isProgram,
      unitType,
      sportName,
      sportMode,
      isAllDistanceRef
    });
    sportSpecificColumns = climbingColumns;
  }
  // 爬楼
  else if (sportName === 'Climb_Stairs') {
    sportSpecificColumns = getClimbStairsColumn();
  }

  const columns: Record<string, BottomTableColumnDefine> = {
    XMode: {
      minWidth: 120,
      title: 'uniqueId',
      status: true,
      canSetStatus: false,
      render({ record: rowData }) {
        return rowData.uniqueId;
      }
    },
    Left_Gap,
    Right_Gap: {
      minWidth: 50,
      status: true,
      canSetStatus: false,
      fixed: 'right'
    },
    ...sportSpecificColumns,
    // 活动
    Activity_Name: {
      title: t('H6007'),
      status: true,
      canSetStatus: false,
      render({ record: rowData, rowIndex: index }) {
        let int;
        if (sportName === 'Ski_Touring') {
          int = getSkiTouringIndex({
            data: rowData
          });
        } else {
          int = getActivityIndex(
            {
              listData,
              data: rowData,
              index,
              isProgram,
              sportName,
              sportMode
            },
            { isAllDistanceRef }
          );
        }
        const activityName = getActivityName(
          {
            data: rowData,
            index,
            isProgram,
            sportName,
            sportMode
          },
          { isAllDistanceRef }
        );

        let result = '';
        if (int && activityName) {
          result = `${int} ${t(activityName)}`;
        } else if (int) {
          result = `${int}`;
        } else if (activityName) {
          result = `${t(activityName)}`;
        }

        // 这里必须要用 inject.isGroupSportRef.value，不能用 isGroupSportRef.value，否则会报错
        if (!inject.isGroupSportRef.value) return result;

        // 换项
        let noteWord = '';
        if (!['Multi_Pitch'].includes(sportName) && listData.value.length !== index + 1)
          noteWord = h('div', { class: 'trasition' }, t('H6019'));

        return h('div', { class: 'index' }, [result, noteWord]);
      }
    },
    // 圈数/趟数
    Laps_Lengths,
    // 跳绳组数
    Jump_Rope_Lengths: {
      title: t('H6013'),
      status: true,
      canSetStatus: false,
      showTips: true,
      render({ record: rowData, rowIndex: index }) {
        const activityIndex = getIndexNew({
          data: rowData,
          isProgram,
          sportName,
          sportMode
        });
        const activityName = getActivityName(
          {
            data: rowData,
            index,
            isProgram,
            sportName,
            sportMode
          },
          { isAllDistanceRef }
        );
        return [
          h('span', { class: 'activity-index' }, activityIndex),
          h('span', { class: 'activity-name' }, activityName ? t(activityName) : '')
        ];
      }
    },
    // 距离
    Distance: {
      title: t('H1040'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        let distance = rowData.distance / 100;

        // 存在用户修改的距离数据，则使用修改后的数据
        if (!unitHelper.noUserChangeDistance(rowData.userChangeDistance)) {
          distance = rowData.userChangeDistance / 100;
        }

        if (!distance) {
          return EMPTY_TEXT;
        }

        const sportType = rowData.sportType;
        // 累积爬升目标类型和距离无关，不使用对应的单位
        const targetUnitName =
          Definition.targetTypeName[rowData.targetType] === CUMULATIVE_CLIMB
            ? ''
            : Definition.getTargetUnitNameByType(rowData.targetDisplayUnit);
        let distanceInfo = {};

        if (lapListTypeIsLap.value && targetUnitName) {
          // 计圈
          const value = {
            km: (val) => {
              return (val / 1000).toFixed(2);
            },
            m: (val) => {
              return val;
            },
            mi: (val) => {
              return unitHelper.distanceM2Mile(val, 2);
            },
            yd: (val) => {
              return unitHelper.distanceM2Yard(val, 2);
            }
          }[targetUnitName](distance);

          distanceInfo = {
            value,
            unit: targetUnitName
          };
        } else {
          distanceInfo = unitHelper.getDistanceInfo(sportType, distance, unitType);
        }

        return `${distanceInfo.value}${distanceInfo.unit}`;
      },
      statistic(data) {
        let value = 0;
        data.forEach((rowData) => {
          let distance = rowData.distance / 100;

          // 存在用户修改的距离数据，则使用修改后的数据
          if (!unitHelper.noUserChangeDistance(rowData.userChangeDistance)) {
            distance = rowData.userChangeDistance / 100;
          }

          if (!distance) {
            distance = 0;
          }

          value += distance;
        });

        const distanceInfo = unitHelper.getDistanceInfo(sportType.value, value, unitType);

        return statisticHtml(distanceInfo.value, distanceInfo.unit);
      },
      frequencyListStatistic({ dataInFrameSelection }) {
        const distanceInfo = distanceStatistic({ dataInFrameSelection, unitType, sportType: sportType.value });
        return statisticHtml(distanceInfo.value, distanceInfo.unit);
      }
    },
    // 滑降距离
    Downhill_Dist: {
      title: t('H1049'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.distance)) {
          return EMPTY_TEXT;
        }

        const distance = rowData.distance;

        // 其他运动
        const unit = {
          [METRIC_UNITS]: 'km',
          [IMPERIAL_UNITS]: 'mi'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return unitHelper.distanceM2Km(value / 100);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2Mile(value / 100);
          }
        }[unitType](distance);

        return `${value}${unit}`;
      },
      statistic(data, key = 'distance') {
        let value = statisticSum(data, key);

        const unit = {
          [METRIC_UNITS]: 'km',
          [IMPERIAL_UNITS]: 'mi'
        }[unitType];

        value = {
          [METRIC_UNITS]: (value) => {
            return unitHelper.distanceM2Km(value / 100);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2Mile(value / 100);
          }
        }[unitType](value);
        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection }) {
        const distanceInfo = distanceStatistic({ dataInFrameSelection, unitType, sportType: sportType.value });
        return statisticHtml(distanceInfo.value, distanceInfo.unit);
      }
    },
    // 组数
    Sets: {
      title: t('H1051'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (!rowData.sets) {
          return EMPTY_TEXT;
        }
        // 休息
        if (Definition.isRestMode(rowData.mode)) {
          return EMPTY_TEXT;
        }
        return t('H8004', { OvO: rowData.sets });
      },
      statistic(data) {
        let value = 0;
        data.forEach((rowData) => {
          // 休息
          if (unitHelper.isNoValue(rowData.sets) || Definition.isRestMode(rowData.mode)) {
            value += 0;
          } else {
            value += rowData.sets;
          }
        });

        return statisticHtml(value, t('H8004', { OvO: '' }));
      }
    },
    // 次数
    Reps: {
      title: t('H6014'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const value = rowData.reps;
        if (!value) {
          return EMPTY_TEXT;
        }
        let target = '';
        if (rowData.targetType === 3 && rowData.targetValue && rowData.targetSets) {
          target = `/${rowData.targetValue * rowData.targetSets}`;
        }
        return `${value}${target}`;
      },
      statistic(data) {
        let value = 0;
        data.forEach((rowData) => {
          if (unitHelper.isNoValue(rowData.reps)) {
            value += 0;
          } else {
            value += rowData.reps;
          }

          if (rowData.targetType === 3 && rowData.targetValue && rowData.targetSets) {
            value += rowData.targetValue * rowData.targetSets;
          }
        });

        return statisticHtml(value, '');
      }
    },
    // 时间
    Time: {
      title: t('H6016'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData, rowIndex: index }) {
        const unit = '';

        // 换项时间
        const noteWord =
          inject.isGroupSportRef.value && !['Multi_Pitch'].includes(sportName) && listData.value.length !== index + 1
            ? h('div', { class: 'trasition' }, unitHelper.s2hms(rowData.transitionTime / 100))
            : '';

        const countTime = inject.isGroupSportRef.value ? rowData.totalTime : rowData.time;

        const noValue = unitHelper.isNoValue(countTime);
        const result = noValue ? EMPTY_TEXT : `${unitHelper.s2hms(Math.round(countTime / 100))}${unit}`;

        if (!noteWord) return result;

        return h('div', { class: 'index' }, [result, noteWord]);
      },
      statistic(data, key = 'time') {
        let value = statisticSum(data, key);

        value = unitHelper.s2hms(Math.round(value / 100));
        const unit = '';
        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection }) {
        const statisticInfo = timeStatistic({ dataInFrameSelection });
        return statisticHtml(statisticInfo.value, statisticInfo.unit);
      }
    },
    // 滑降时间
    Downhill_Time: {
      title: t('H1053'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        return unitHelper.s2hms(Math.round(rowData.downhillTime / 100));
      },
      statistic(data, key = 'downhillTime') {
        let value = statisticSum(data, key);

        value = unitHelper.s2hms(Math.round(value / 100));
        const unit = '';
        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection }) {
        const statisticInfo = timeStatistic({ dataInFrameSelection });
        return statisticHtml(statisticInfo.value, statisticInfo.unit);
      }
    },
    // 累计时间
    Total_Length: {
      title: t('H6015'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const time = rowData.totalTime || rowData.totalLength || rowData.time;
        const noValue = unitHelper.isNoValue(time);
        return noValue ? EMPTY_TEXT : `${unitHelper.s2hms(Math.round(time / 100))}${unit}`;
      },
      statistic() {
        return [EMPTY_TEXT_SINGLE, EMPTY_TEXT_SINGLE];
      },
      frequencyListStatistic() {
        return [EMPTY_TEXT_SINGLE, EMPTY_TEXT_SINGLE];
      }
    },
    // 平均配速
    Avg_Pace: {
      title: t('H1054'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const { avgPace, avgSpeed } = rowData;
        let { speedUnit } = rowData;
        let pace = avgPace || avgSpeed;
        if (sportName === 'Custom_Sport') {
          pace = avgPace;
          speedUnit = 3;
        }
        if ([undefined, null, '', 0].includes(pace)) {
          return EMPTY_TEXT;
        }
        if (sportName === 'Custom_Sport') {
          const value = unitHelper.getSpeedValueWithSpeedType(speedUnit, pace, 2, unitType);
          const unit = unitHelper.getSpeedUnitText(speedUnit, unitType);
          return `${value}${unit}`;
        } else {
          const value = unitHelper.getPaceValue(pace, sportType.value, 2, unitType);
          const unit = unitHelper.getPaceUnit(sportType.value, unitType);
          return `${value}${unit}`;
        }
      },
      statistic(data, key = 'avgSpeed') {
        let count = 0;
        let value = 0;
        data.forEach((rowData) => {
          const val = rowData.avgPace || rowData.avgSpeed;
          if (unitHelper.isNoValue(val)) {
            value += 0;
          } else {
            count++;
            value += val;
          }
        });

        value = unitHelper.getPaceValue(value / count, sportType.value, 2, unitType);
        const unit = unitHelper.getPaceUnit(sportType.value, unitType);
        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'speed') {
        const start = data[0];
        const end = data[data.length - 1];
        if (end.distance - start.distance === 0) {
          return EMPTY_TEXT;
        }
        const time = (end.activityTimestamp - start.activityTimestamp) / 100;
        const distance = mathUnit(end.distance - start.distance, 'cm');

        let transformedDistance = distance.toNumber('km');
        if (['Pool_Swim', 'Open_Water'].includes(sportName)) {
          transformedDistance = distance.toNumber('hm');
        } else if (['Row', 'Indoor_Row'].includes(sportName)) {
          // 500m
          transformedDistance = distance.toNumber('hm') / 5;
        }

        // getPaceValue 需要传入正确单位的数据（公制）
        const value = distance ? unitHelper.getPaceValue(time / transformedDistance, sportType.value, 2, unitType) : 0;

        const unit = unitHelper.getPaceUnit(sportType.value, unitType);
        return statisticHtml(value, unit);
      }
    },
    // 平均速度
    Avg_Speed: {
      title: t('H1020'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const { avgSpeed, speedUnit, avgSpeedV2, ropeAvgSpeed } = rowData;
        if (sportName === 'Custom_Sport') {
          let value = avgSpeedV2;
          if (!value) {
            return EMPTY_TEXT;
          }
          const _speedUnit = 1;
          value = unitHelper.getSpeedValueWithSpeedType(_speedUnit, value, 1, unitType);
          const unit = unitHelper.getSpeedUnitText(_speedUnit, unitType);
          return `${value}${unit}`;
        }
        // 当为铁人三项、组合运动时，取speed，然后根据speedUnit来显示 , 'Ski_Touring', 'Ski_Touring_Old'
        if (['Triathlon', 'Multi_Sport'].includes(sportName)) {
          let value = avgSpeed;
          if (!value) {
            return EMPTY_TEXT;
          }
          value = unitHelper.getSpeedValueWithSpeedType(speedUnit, value, 1, unitType);
          const unit = unitHelper.getSpeedUnitText(speedUnit, unitType);
          return `${value}${unit}`;
        }

        if (['Run', 'Indoor_Run', 'Trail_Run', 'Track_Run'].includes(sportName)) {
          let value = avgSpeedV2;
          if (!value) {
            return EMPTY_TEXT;
          }

          value = {
            [METRIC_UNITS]: (value) => {
              return value.toFixed(1);
            },
            [IMPERIAL_UNITS]: (value) => {
              return unitHelper.distanceKm2Mi(value, 1);
            }
          }[unitType](value / 100);

          const unit = {
            [METRIC_UNITS]: 'km/h',
            [IMPERIAL_UNITS]: 'mph'
          }[unitType];

          return `${value}${unit}`;
        }

        if (['Jump_Rope'].includes(sportName)) {
          const value = ropeAvgSpeed || avgSpeedV2;
          if (!value) {
            return EMPTY_TEXT;
          }

          const unit = 'reps/min';

          return `${value}${unit}`;
        }

        // 其他运动类型
        if ([undefined, null, '', 0].includes(rowData.avgSpeed) && [undefined, null, '', 0].includes(rowData.avgSpeedV2)) {
          return EMPTY_TEXT;
        }

        // console.log('unitHelper.getSpeedUnit, ', sportType.value, unitType, rowData.speedUnit);
        const unit = unitHelper.getSpeedUnit(sportType.value, unitType, rowData.speedUnit);
        // 除竞速帆板运动外，其他运动类型的速度由两位小数改为一位小数
        const fixed = sportType.value === 706 ? 2 : 1;
        const value = unitHelper.getSpeedValue(avgSpeedV2, sportType.value, fixed, unitType);

        return `${value}${unit}`;
      },
      statistic(data, key = 'avgSpeed') {
        let unit = '';
        let value = '';

        if (['Triathlon', 'Multi_Sport', 'Ski_Touring', 'Ski_Touring_Old'].includes(Definition.getSportNameByType(sportType.value))) {
          key = 'avgSpeedV2';

          unit = unitHelper.getSpeedUnitText(data[0].speedUnit, unitType);
          // 除竞速帆板运动外，其他运动类型的速度由两位小数改为一位小数
          const fixed = sportType.value === 706 ? 2 : 1;
          value = unitHelper.getSpeedValueWithSpeedType(data[0].speedUnit, statisticAvg(data, key), fixed, unitType);
        } else if (['Run', 'Indoor_Run', 'Trail_Run', 'Track_Run', 'Custom_Sport'].includes(sportName)) {
          key = 'avgSpeedV2';

          value = {
            [METRIC_UNITS]: (value) => {
              return value.toFixed(1);
            },
            [IMPERIAL_UNITS]: (value) => {
              return unitHelper.distanceKm2Mi(value, 1);
            }
          }[unitType](statisticAvg(data, key) / 100);

          unit = {
            [METRIC_UNITS]: 'km/h',
            [IMPERIAL_UNITS]: 'mph'
          }[unitType];
        } else if (['Jump_Rope'].includes(sportName)) {
          let countNum = 0;
          value = 0;
          data.forEach((item) => {
            if (Definition.isRestMode(item.mode)) {
              return;
            }
            countNum++;
            value += Number(item.ropeAvgSpeed || item.avgSpeed);
          });

          value = Math.round(value / countNum);

          unit = 'reps/min';
        } else {
          value = unitHelper.getSpeedValue(statisticAvg(data, ['avgSpeed', 'avgSpeedV2']), sportType.value, 2, unitType);

          unit = unitHelper.getSpeedUnit(sportType.value, unitType, data[0].speedUnit);
        }

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'speed') {
        if (['Jump_Rope'].includes(sportName)) {
          const unit = 'reps/min';

          let count = 0;
          let num = 0;
          data.forEach((item) => {
            if (item.speed2 > 0) {
              count += item.speed2;
              num++;
            }
          });

          const value = num > 0 ? Math.round(count / num) : 0;
          return statisticHtml(value, unit);
        }

        const start = data[0];
        const end = data[data.length - 1];
        const time = (end.activityTimestamp - start.activityTimestamp) / 100 / 3600;
        const distance = ((end.distance - start.distance) / 100 / 1000) * 100;
        const speed = distance / time;

        let unit = '';
        let value = '';

        if (['Triathlon', 'Multi_Sport', 'Ski_Touring', 'Ski_Touring_Old'].includes(Definition.getSportNameByType(sportType.value))) {
          unit = unitHelper.getSpeedUnitText(summary.speedUnit, unitType);
          // 除竞速帆板运动外，其他运动类型的速度由两位小数改为一位小数
          const fixed = sportType.value === 706 ? 2 : 1;
          value = unitHelper.getSpeedValueWithSpeedType(summary.speedUnit, speed, fixed, unitType);
        } else if (['Run', 'Indoor_Run', 'Trail_Run', 'Track_Run'].includes(sportName)) {
          value = {
            [METRIC_UNITS]: (value) => {
              return value.toFixed(1);
            },
            [IMPERIAL_UNITS]: (value) => {
              return unitHelper.distanceKm2Mi(value, 1);
            }
          }[unitType](speed / 100);

          unit = {
            [METRIC_UNITS]: 'km/h',
            [IMPERIAL_UNITS]: 'mph'
          }[unitType];
        } else {
          unit = unitHelper.getSpeedUnit(sportType.value, unitType, summary.speedUnit);

          value = unitHelper.getSpeedValue(speed, sportType.value, 2, unitType);
        }

        return statisticHtml(value, unit);
      }
    },
    // 最快速度
    Max_Speed: {
      title: t('H1023'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (['Jump_Rope'].includes(sportName)) {
          const value = rowData.ropeMaxSpeed;
          if (!value) {
            return EMPTY_TEXT;
          }

          const unit = 'reps/min';

          return `${value}${unit}`;
        }

        let value = rowData.maxSpeed;
        if (!value) {
          return EMPTY_TEXT;
        }

        const units = unitHelper.getSpeedUnit(sportType.value, unitType, rowData.speedUnit);

        value = {
          [METRIC_UNITS]: unitHelper.distanceM2Km,
          [IMPERIAL_UNITS]: unitHelper.distanceM2Mile
        }[unitType](rowData.maxSpeed * 10, 1);

        return `${value}${units}`;
      },
      statistic(data, key = 'maxSpeed', unit = '') {
        if (['Jump_Rope'].includes(sportName)) {
          key = 'ropeMaxSpeed';
          unit = 'reps/min';
          let value = 0;

          data.forEach((item) => {
            if (Definition.isRestMode(item.mode)) {
              return;
            }
            if (item[key] > value) {
              value = item[key];
            }
          });

          return statisticHtml(value, unit);
        }

        unit = unitHelper.getSpeedUnit(sportType.value, unitType, speedUnit);

        const value = {
          [METRIC_UNITS]: unitHelper.distanceM2Km,
          [IMPERIAL_UNITS]: unitHelper.distanceM2Mile
        }[unitType](statisticMax(data, key) * 10);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'speed', unit = '') {
        if (['Jump_Rope'].includes(sportName)) {
          key = 'speed2';
          unit = 'reps/min';
          const value = statisticMax(data, key);
          return statisticHtml(value, unit);
        }
        return columns.Max_Speed.statistic(data, key);
      }
    },
    // 垂直速度
    Vert_Speed: {
      title: t('H1021'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.vertSpeed)) {
          return EMPTY_TEXT;
        }

        const unit = {
          [METRIC_UNITS]: 'm/h',
          [IMPERIAL_UNITS]: 'ft/h'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value;
          },
          [IMPERIAL_UNITS]: unitHelper.distanceM2ft
        }[unitType](rowData.vertSpeed);

        return `${value}${unit}`;
      },
      statistic(data, key = 'vertSpeed') {
        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(2);
          },
          [IMPERIAL_UNITS]: unitHelper.distanceM2ft
        }[unitType](statisticAvg(data, key));

        const unit = {
          [METRIC_UNITS]: 'm/h',
          [IMPERIAL_UNITS]: 'ft/h'
        }[unitType];

        return statisticHtml(value, unit);
      }
    },
    // 平均功率
    Avg_Power: {
      title: t('H1025'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const units = 'w';
        const noValue = unitHelper.isNoValue(rowData.avgPower);
        return noValue ? EMPTY_TEXT : `${rowData.avgPower}${units}`;
      },
      statistic(data, key = 'avgPower') {
        const value = Math.round(statisticAvg(data, key));

        const units = 'w';

        return statisticHtml(value, units);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'power') {
        return columns.Avg_Power.statistic(data, key);
      }
    },
    // 强度
    weight: {
      title: t('H6017'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        // 当intensityType = 1时，intensityCustom = 0，
        // 强度 取intensityValue  ，目前接口返回的单位是g，需/1000，单位为kg，英制单位为lbs（系统切换公英制），1lbs=0.4536kg
        // 当intensityType = 1，intensityCustom = 1，
        // 强度 直接展示 “体重”

        if (rowData.intensityType === 1 && rowData.intensityCustom === 0) {
          const noValue = unitHelper.isNoValue(rowData.intensityValue);
          if (noValue) {
            return EMPTY_TEXT;
          }

          const intensityUnitName = Definition.getIntensityUnitNameByType(rowData.intensityDisplayUnit);

          let unit = '';
          if (intensityUnitName) {
            unit = intensityUnitName;
          } else {
            unit = {
              [METRIC_UNITS]: 'kg',
              [IMPERIAL_UNITS]: 'lbs'
            }[unitType];
          }

          const value = {
            kg: (value) => {
              return value / 1000;
            },
            lbs: (value) => {
              return unitHelper.weightKg2Lbs(value / 1000, 2);
            }
          }[unit](rowData.intensityValue);
          return `${value}${unit}`;
        }

        if (rowData.intensityType === 1 && rowData.intensityCustom === 1) {
          return t('TG4007');
        }
        return EMPTY_TEXT;
      }
    },
    // 平均心率
    Avg_HR: {
      title: t('H1055'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const noValue = unitHelper.isNoValue(rowData.avgHr);
        return noValue || [0, '0'].includes(rowData.avgHr) ? EMPTY_TEXT : `${rowData.avgHr}${unit}`;
      },
      statistic(data, key = 'avgHr') {
        const value = Math.round(statisticAvg(data, key));
        const unit = '';
        let html = '';
        const noValue = unitHelper.isNoValue(value);
        html = noValue || [0, '0'].includes(value) ? EMPTY_TEXT : statisticHtml(value, unit);
        return html;
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'heart') {
        return columns.Avg_HR.statistic(data, key);
      }
    },
    // 最大心率
    Max_HR: {
      title: t('H6022'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const noValue = unitHelper.isNoValue(rowData.maxHr);
        return noValue || [0, '0'].includes(rowData.maxHr) ? EMPTY_TEXT : `${rowData.maxHr}${unit}`;
      },
      statistic(data, key = 'maxHr') {
        const unit = '';
        let html = '';
        const value = statisticMax(data, key);
        const noValue = unitHelper.isNoValue(value);
        html = noValue || [0, '0'].includes(value) ? EMPTY_TEXT : statisticHtml(value, unit);
        return html;
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'heart') {
        return columns.Max_HR.statistic(data, key);
      }
    },
    // 跑步效率
    Run_Efficiency: {
      title: t('H5035'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.runEfficiency)) {
          return EMPTY_TEXT;
        }
        return Math.floor(rowData.runEfficiency / 10);
      },
      statistic(data, key = 'runEfficiency') {
        const value = Math.floor(statisticAvg(data, key) / 10);

        const unit = '';

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'runningEfficiency') {
        return columns.Run_Efficiency.statistic(data, key);
      }
    },
    // 踏地时间
    Ground_Time: {
      title: t('H5009'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = 'ms';
        const noValue = unitHelper.isNoValue(rowData.groundTime);
        return noValue ? EMPTY_TEXT : `${rowData.groundTime}${unit}`;
      },
      statistic(data, key = 'groundTime') {
        const value = Math.round(statisticAvg(data, key));

        const unit = 'ms';

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'groundTime') {
        return columns.Ground_Time.statistic(data, key);
      }
    },
    // 左右平衡
    L_R_Balance: {
      title: isBikeSport ? t('H9096') : t('H5011'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const groundBalance = rowData.groundBalance;
        // 左右平衡，需要*10%，如果左平衡大于等于右平衡，就显示左平衡，如果左平衡小余右平衡就显示右平衡，显示举例52%左    51.5%右
        if (!groundBalance) {
          return EMPTY_TEXT;
        }
        const unit = '%';

        let result = EMPTY_TEXT;
        if (isBikeSport) {
          if (groundBalance <= 0 || groundBalance >= 100) return EMPTY_TEXT;
          const leftValue = Math.round(groundBalance);
          return `${leftValue}${unit} - ${100 - leftValue}${unit}`;
        }
        if (groundBalance === 50) {
          result = `${100 - groundBalance}${unit}`;
        } else if (groundBalance > 50) {
          result = `${groundBalance}${unit}L`;
        } else {
          result = `${100 - groundBalance}${unit}R`;
        }
        return result;
      },
      statistic(data, key = 'groundBalance') {
        let count = 0;
        let unit = '%';
        if (isBikeSport) {
          count = Number(statisticAvg(data, key).toFixed(0));
          if (count === 0) return EMPTY_TEXT;
          return [`${count}${unit} - ${100 - count}${unit}`, ''];
        }
        count = Number(statisticAvg(data, key).toFixed(1));
        if (count === 0) {
          count = EMPTY_TEXT;
          unit = '';
        } else if (count === 50) {
          count = 100 - count;
        } else if (count > 50) {
          unit = `${unit}L`;
        } else {
          count = 100 - count;
          unit = `${unit}R`;
        }

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'leftGroundBalance') {
        // 过滤无效数据
        const filterData = data.filter((item) => item.leftGroundBalance > 0 && item.leftGroundBalance < 100);
        return columns.L_R_Balance.statistic(filterData, key);
      }
    },
    // 平均步频
    Avg_Step_Cadence: {
      title: t('H1030'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const noValue = unitHelper.isNoValue(rowData.avgCadence);
        return noValue ? EMPTY_TEXT : `${rowData.avgCadence}${unit}`;
      },
      statistic(data, key = 'avgCadence') {
        const count = Math.round(statisticAvg(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'cadence') {
        return columns.Avg_Step_Cadence.statistic(data, key);
      }
    },
    // 最大步频
    Max_Cadence: {
      title: t('H1031'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const noValue = unitHelper.isNoValue(rowData.maxCadence);
        return noValue ? EMPTY_TEXT : `${rowData.maxCadence}${unit}`;
      },
      statistic(data, key = 'maxCadence') {
        const max = statisticMax(data, key);

        const unit = '';

        return statisticHtml(max, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'cadence') {
        return columns.Max_Cadence.statistic(data, key);
      }
    },
    // 平均踏频
    Avg_Cadence: {
      title: t('H1032'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const noValue = unitHelper.isNoValue(rowData.avgCadence);
        return noValue ? EMPTY_TEXT : `${rowData.avgCadence}${unit}`;
      },
      statistic(data, key = 'avgCadence') {
        const count = Math.round(statisticAvg(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'cadence') {
        return columns.Avg_Cadence.statistic(data, key);
      }
    },
    // 划频
    Swim_Stroke_Rate: {
      title: t('H5021'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (!rowData.avgStrokeRateLen) {
          return EMPTY_TEXT;
        }
        const unit = 'strokes/min';
        return `${rowData.avgStrokeRateLen}${unit}`;
      },
      statistic(data, key = 'avgStrokeRateLen') {
        const count = Math.round(statisticAvg(data, key));

        const unit = 'strokes/min';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'cadence') {
        return columns.Swim_Stroke_Rate.statistic(data, key);
      }
    },
    // 平均桨频
    Row_Stroke_Rate: {
      title: t('H1062'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '';
        const noValue = unitHelper.isNoValue(rowData.avgCadence);
        return noValue ? EMPTY_TEXT : `${rowData.avgCadence}${unit}`;
      },
      statistic(data, key = 'avgCadence') {
        const count = Math.round(statisticAvg(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'cadence') {
        return columns.Row_Stroke_Rate.statistic(data, key);
      }
    },
    // 垂直步幅比
    Stride_Ratio: {
      title: t('H5017'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '%';
        const noValue = unitHelper.isNoValue(rowData.strideRatio);
        return noValue ? EMPTY_TEXT : `${rowData.strideRatio / 10}${unit}`;
      },
      statistic(data, key = 'strideRatio') {
        const count = Number((statisticAvg(data, key) / 10).toFixed(1));

        const unit = '%';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'verticalStrideRatio') {
        return columns.Stride_Ratio.statistic(data, key);
      }
    },
    // 垂直振幅
    Stride_Height: {
      title: t('H5013'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.strideHeight)) {
          return EMPTY_TEXT;
        }

        const unit = {
          [METRIC_UNITS]: 'cm',
          [IMPERIAL_UNITS]: 'inch'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value / 10;
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceCM2inch(value / 10, 1, unitType);
          }
        }[unitType](rowData.strideHeight);

        return `${value}${unit}`;
      },
      statistic(data, key = 'strideHeight') {
        const unit = {
          [METRIC_UNITS]: 'cm',
          [IMPERIAL_UNITS]: 'inch'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value / 10;
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceCM2inch(value / 10, 1, unitType);
          }
        }[unitType](statisticAvg(data, key));

        return statisticHtml(Math.round(value), unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'verticalVibration') {
        return columns.Stride_Height.statistic(data, key);
      }
    },
    // 平均步幅
    Avg_Stride_Length: {
      title: t('H6023'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.avgStrideLength)) {
          return EMPTY_TEXT;
        }
        const unit = {
          [METRIC_UNITS]: 'cm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return Math.floor(value);
            // return value.toFixed(2)
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value / 100, 2, unitType);
          }
        }[unitType](rowData.avgStrideLength);

        return `${value}${unit}`;
      },
      statistic(data, key = 'avgStrideLength') {
        const count = Math.round(statisticAvg(data, key));

        const unit = {
          [METRIC_UNITS]: 'cm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return Math.floor(value);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value / 100, 2, unitType);
          }
        }[unitType](count);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'cadenceLength') {
        return columns.Avg_Stride_Length.statistic(data, key);
      }
    },
    // 姿势功率
    Form_Power: {
      title: t('H5023'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = 'w';
        const noValue = unitHelper.isNoValue(rowData.formPower);
        return noValue ? EMPTY_TEXT : `${rowData.formPower}${unit}`;
      },
      statistic(data, key = 'formPower') {
        const count = Math.round(statisticAvg(data, key));

        const unit = 'w';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'formPower') {
        return columns.Form_Power.statistic(data, key);
      }
    },
    // 下肢刚度
    Leg_Stiffness: {
      title: t('H5025'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.legStiffness)) {
          return EMPTY_TEXT;
        }

        const unit = {
          [METRIC_UNITS]: 'kN/m',
          [IMPERIAL_UNITS]: 'kN/ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value;
          },
          // 因为是被除数，转换要颠倒过来
          // 即被除数要乘以 0.3048，则整体要除以 0.3048
          [IMPERIAL_UNITS]: (value) => {
            return Number(value * 0.3048).toFixed(1);
          }
        }[unitType](rowData.legStiffness / 10);

        return `${value}${unit}`;
      },
      statistic(data, key = 'legStiffness') {
        const count = Math.round(statisticAvg(data, key) / 10);

        const unit = {
          [METRIC_UNITS]: 'kN/m',
          [IMPERIAL_UNITS]: 'kN/ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(1);
          },
          // 因为是被除数，转换要颠倒过来
          // 即被除数要乘以 0.3048，则整体要除以 0.3048
          [IMPERIAL_UNITS]: (value) => {
            return Number(value * 0.3048).toFixed(1);
          }
        }[unitType](count);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'legStiffness') {
        return columns.Leg_Stiffness.statistic(data, key);
      }
    },
    // 踏地角度
    // Landing_Angle: {
    //   title: t('H9043'),
    //   status: true,
    //   canSetStatus: true,
    //   showTips: true,
    //   render({ record: rowData,  }) {
    //     if (unitHelper.isNoValue(rowData.strikeAngle)) {
    //       return EMPTY_TEXT;
    //     }

    //     const unit = '°';

    //     return `${rowData.strikeAngle}${unit}`;
    //   },
    //   statistic(data, key = 'strikeAngle') {
    //     const count = Math.round(statisticAvg(data, key));

    //     const unit = '°';

    //     return statisticHtml(count.toFixed(1), unit);
    //   },
    //   frequencyListStatistic({ dataInFrameSelection: data }, key = 'strikeAngle') {
    //     return columns.Landing_Angle.statistic(data, key);
    //   }
    // },
    // 地反力峰值
    // Vertical_Ground_Reaction_Force: {
    //   title: t('H9042'),
    //   status: true,
    //   canSetStatus: true,
    //   showTips: true,
    //   render({ record: rowData,  }) {
    //     if (unitHelper.isNoValue(rowData.maxForce)) {
    //       return EMPTY_TEXT;
    //     }

    //     const unit = 'kN';

    //     return `${rowData.maxForce / 10}${unit}`;
    //   },
    //   statistic(data, key = 'maxForce') {
    //     const count = Math.round(statisticAvg(data, key) / 10);

    //     const unit = 'kN';

    //     return statisticHtml(count.toFixed(1), unit);
    //   },
    //   frequencyListStatistic({ dataInFrameSelection: data }, key = 'maxForce') {
    //     return columns.Vertical_Ground_Reaction_Force.statistic(data, key);
    //   }
    // },
    // 风阻系数
    Air_Power: {
      title: t('H5027'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '%';
        const noValue = unitHelper.isNoValue(rowData.airPower);
        return noValue ? EMPTY_TEXT : `${rowData.airPower}${unit}`;
      }
    },
    // 划次
    Strokes: {
      title: t('H5019'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (!rowData.strokes) {
          return EMPTY_TEXT;
        }
        const unit = '';
        return `${rowData.strokes}${unit}`;
      },
      statistic(data, key = 'strokes') {
        const count = Math.round(statisticAvg(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'swimStorkes') {
        return columns.Strokes.statistic(data, key);
      }
    },
    // SWOLF
    SWOLF: {
      title: t('H1029'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (!rowData.avgSwolf) {
          return EMPTY_TEXT;
        }
        const unit = '';
        return `${rowData.avgSwolf}${unit}`;
      },
      statistic(data, key = 'avgSwolf') {
        const count = Math.round(statisticAvg(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'swimSwolf') {
        return columns.SWOLF.statistic(data, key);
      }
    },
    // 累计上升
    Elev_Gain: {
      title: t('H1034'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.elevGain)) {
          return EMPTY_TEXT;
        }
        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](rowData.elevGain);

        return `${value}${unit}`;
      },
      statistic(data, key = 'elevGain') {
        const max = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](statisticSum(data, key));

        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        return statisticHtml(max, unit);
      },
      frequencyListStatistic({ lapInfo }) {
        if (!lapInfo) return '--';
        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];
        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](lapInfo?.elevGain);
        return statisticHtml(value, unit);
      }
    },
    // 累计下降
    Total_Descent: {
      title: t('H1035'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.totalDescent)) {
          return EMPTY_TEXT;
        }
        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](rowData.totalDescent);

        return `${value}${unit}`;
      },
      statistic(data, key = 'totalDescent') {
        const max = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](statisticSum(data, key));

        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        return statisticHtml(max, unit);
      },
      frequencyListStatistic({ dataInFrameSelection, lapInfo }) {
        if (!lapInfo) return '--';
        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];
        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](lapInfo?.totalDescent);
        return statisticHtml(value, unit);
      }
    },
    // 滑降下降
    Downhill_Desc: {
      title: t('H1036'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.downhillDesc)) {
          return EMPTY_TEXT;
        }
        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        const value = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](rowData.downhillDesc);

        return `${value}${unit}`;
      },
      statistic(data, key = 'downhillDesc') {
        const max = {
          [METRIC_UNITS]: (value) => {
            return value.toFixed(0);
          },
          [IMPERIAL_UNITS]: (value) => {
            return unitHelper.distanceM2ft(value, 0, unitType);
          }
        }[unitType](statisticMax(data, key));

        const unit = {
          [METRIC_UNITS]: 'm',
          [IMPERIAL_UNITS]: 'ft'
        }[unitType];

        return statisticHtml(max, unit);
      }
    },
    // 坡度
    Grade: {
      title: t('H6009'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '%';
        const noValue = unitHelper.isNoValue(rowData.avgGrade);
        return noValue ? EMPTY_TEXT : `${rowData.avgGrade}${unit}`;
      },
      statistic(data, key = 'avgGrade') {
        const count = Math.round(statisticAvg(data, key));

        const unit = '%';

        return statisticHtml(count, unit);
      }
    },
    // 最大坡度
    Max_Grade: {
      title: t('H1037'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = '%';
        const noValue = unitHelper.isNoValue(rowData.maxGrade);
        return noValue ? EMPTY_TEXT : `${rowData.maxGrade}${unit}`;
      },
      statistic(data, key = 'maxGrade') {
        const max = statisticMax(data, key);

        const unit = '%';

        return statisticHtml(max, unit);
      }
    },
    // 卡路里
    Calories: {
      title: t('H1038'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const unit = 'kcal';
        const noValue = unitHelper.isNoValue(rowData.calories);
        return noValue ? EMPTY_TEXT : `${(rowData.calories / 1000).toFixed(0)}${unit}`;
      },
      statistic(data, key = 'calories') {
        const unit = 'kcal';

        const value = (statisticSum(data, key) / 1000).toFixed(0);

        return statisticHtml(value, unit);
      }
    },
    // 步数
    Steps: {
      title: t('H5044'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        return rowData.totalCadence || EMPTY_TEXT;
      },
      statistic(data, key = 'totalCadence') {
        const count = statisticSum(data, key);

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }) {
        return columns.Steps.statistic(data);
      }
    },
    // 体温
    Body_Temperature: {
      title: t('H9023'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        let value = rowData.bodyTemperature;
        if (!value) {
          return EMPTY_TEXT;
        }

        const unit = corosSportConfig.basic.temperature.getUnit(finalTemperatureUnitType);

        const isMeric = finalTemperatureUnitType === METRIC_UNITS;
        const val = rowData.bodyTemperature / 100;
        value = isMeric ? val.toFixed(2) : corosSportConfig.basic.temperature.convertValueC2F(val, 2);

        return `${value}${unit}`;
      },
      statistic(data, key = 'bodyTemperature') {
        let value = statisticAvg(data, key);

        const isMeric = finalTemperatureUnitType === METRIC_UNITS;
        const val = value / 100;
        value = isMeric ? val : corosSportConfig.basic.temperature.convertValueC2F(val, 0);

        const unit = corosSportConfig.basic.temperature.getUnit(finalTemperatureUnitType);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'bodyTemperature') {
        return columns.Body_Temperature.statistic(data, key);
      },
      useIt() {
        return Reflect.has(inject.graphObjRef.value, 'bodyTemperature');
      }
    },
    // 水温
    Water_Temperature: {
      title: t('H9022'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        let value = rowData.waterTemperature;
        if (!value) {
          return EMPTY_TEXT;
        }

        const unit = corosSportConfig.basic.temperature.getUnit(finalTemperatureUnitType);

        const isMeric = finalTemperatureUnitType === METRIC_UNITS;
        const val = rowData.waterTemperature / 100;
        value = isMeric ? val : corosSportConfig.basic.temperature.convertValueC2F(val, 0);

        return `${value}${unit}`;
      },
      statistic(data, key = 'waterTemperature') {
        let value = statisticAvg(data, key);

        const unit = corosSportConfig.basic.temperature.getUnit(finalTemperatureUnitType);
        const isMeric = finalTemperatureUnitType === METRIC_UNITS;
        const val = value / 100;
        value = isMeric ? val : corosSportConfig.basic.temperature.convertValueC2F(val, 0);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'waterTemperature') {
        return columns.Water_Temperature.statistic(data, key);
      },
      useIt() {
        return Reflect.has(inject.graphObjRef.value, 'waterTemperature');
      }
    },
    // 等价配速
    Adjusted_Pace: {
      title: t('H9024'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (!['Run', 'Trail_Run', 'Custom_Sport'].includes(sportName)) {
          return EMPTY_TEXT;
        }

        if ([undefined, null, '', 0].includes(rowData.adjustedPace)) {
          return EMPTY_TEXT;
        }

        const value = unitHelper.getPaceValue(rowData.adjustedPace, sportType.value, 2, unitType);
        const unit = unitHelper.getPaceUnit(sportType.value, unitType);
        return `${value}${unit}`;
      },
      statistic(data, key = 'adjustedPace') {
        if (!['Run', 'Trail_Run', 'Custom_Sport'].includes(sportName)) {
          return EMPTY_TEXT;
        }

        let value = statisticAvg(data, key);

        value = unitHelper.getPaceValue(value, sportType.value, 2, unitType);
        const unit = unitHelper.getPaceUnit(sportType.value, unitType);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'adjustedPace') {
        return columns.Adjusted_Pace.statistic(data, key);
      }
    },
    // 等价速度
    Adjusted_Speed: {
      title: t('H9025'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (!['XC_Ski', 'Ski_Touring'].includes(sportName)) {
          return EMPTY_TEXT;
        }

        if ([undefined, null, '', 0].includes(rowData.adjustedPace)) {
          return EMPTY_TEXT;
        }

        const unit = unitHelper.getSpeedUnit(sportType.value, unitType, rowData.speedUnit);

        const value = unitHelper.getSpeedValue(rowData.adjustedPace, sportType.value, 2, unitType);

        return `${value}${unit}`;
      },
      statistic(data, key = 'adjustedPace') {
        if (!['XC_Ski', 'Ski_Touring', 'Ski_Touring_Old'].includes(sportName)) {
          return EMPTY_TEXT;
        }

        let value = statisticAvg(data, key);

        value = unitHelper.getSpeedValue(value, sportType.value, 2, unitType);

        const unit = unitHelper.getSpeedUnit(sportType.value, unitType, speedUnit);

        return statisticHtml(value, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'adjustedPace') {
        return columns.Adjusted_Speed.statistic(data, key);
      }
    },
    // 达标率
    StandardRate: {
      title: t('TD1065'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if ([undefined, null, ''].includes(rowData.standardRate) || rowData.standardRate < 0) {
          return EMPTY_TEXT;
        }

        const value = rowData.standardRate ? (rowData.standardRate * 100).toFixed(1) : '0';
        const unit = '%';

        return `${value}${unit}`;
      },
      useIt() {
        return isProgram;
      }
    },
    // 最多连跳
    Max_Cont_Jumps: {
      title: t('H9026'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const value = rowData.maxJump;
        if (!value) {
          return EMPTY_TEXT;
        }
        const unit = '';
        return `${value}${unit}`;
      },
      statistic(data, key = 'maxJump') {
        const count = Math.round(statisticMax(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'jump') {
        return columns.Max_Cont_Jumps.statistic(data, key);
      }
    },
    // 绊绳次数
    Stumble_Rope: {
      title: t('H9030'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        const value = rowData.stumbleRope;
        if (!value) {
          return EMPTY_TEXT;
        }
        const unit = '';
        return `${value}${unit}`;
      },
      statistic(data, key = 'stumbleRope') {
        const count = Math.round(statisticSum(data, key));

        const unit = '';

        return statisticHtml(count, unit);
      },
      frequencyListStatistic({ dataInFrameSelection: data }, key = 'stumbleRope') {
        let count = 0;

        data.forEach((item) => {
          if (Reflect.has(item, 'maxJump')) {
            count++;
          }
        });
        return count;
      }
    },
    NP: {
      title: t('H1027'),
      status: true,
      canSetStatus: true,
      showTips: true,
      render({ record: rowData }) {
        if (unitHelper.isNoValue(rowData.np)) {
          return EMPTY_TEXT;
        }

        return rowData.np + 'w';
      },
      statistic(data, key = 'np') {
        const value = Math.round(statisticAvg(data, key));
        return [value, 'w'];
      },
      frequencyListStatistic({ dataInFrameSelection, lapInfo }) {
        if (!lapInfo) return '--';
        const value = lapInfo?.np;
        return [value, 'w'];
      }
    }
  };

  // 跳绳特殊处理
  if (sportType.value === 901 && isInterval.value) {
    Object.keys(columns)
      .filter((key) =>
        [
          //
          'Reps',
          'Avg_Speed',
          'Max_Speed',
          'Max_Cont_Jumps',
          'Stumble_Rope',
          'Calories',
          'Max_HR'
        ].includes(key)
      )
      .forEach((key) => {
        const columnItem: TableData = columns[key];
        const oldRender = columnItem.render!;
        columns[key].render = ({ record, rowIndex: index }) => {
          if (Definition.isRestMode(record.mode)) {
            return '';
          }
          return oldRender({ record, rowIndex: index });
        };
      });
  }
  // 游泳特殊处理
  // 分解动作不显示
  else if ([300, 301].includes(sportType.value)) {
    Object.keys(columns)
      .filter((key) => ['SWOLF'].includes(key))
      .forEach((key) => {
        const newItem = columns[key];

        const oldRender = newItem.render!;
        newItem.render = ({ record, rowIndex: index }) => {
          if (key === 'SWOLF' && record.swimStyle === corosSportConfig.sport.poolSwim.SWIM_STYLE_TYPE.DRILLS) {
            return 0;
          } else if (key === 'SWOLF' && record.distance === 0) {
            return 0;
          }
          return oldRender({ record, rowIndex: index });
        };

        return 0;
      });

    // 补的趟
    Object.keys(columns).forEach((key) => {
      if (
        // 2、间歇训练和训练组合的恢复
        // 3、距离=0（或固件没传距离），则仅显示时间、心率、水温（自由模式样式一致）
        (isProgram || (!isProgram && summary.sportMode === SportMode.INTERVAL)) &&
        ![
          'Water_Temperature',
          'Distance',
          'Avg_Pace',
          'Time',
          'Left_Gap',
          'Right_Gap',
          'Laps_Lengths',
          'EndTime',
          'StartTime',
          'XMode'
        ].includes(key)
      ) {
        const newItem = columns[key];
        const oldRender = newItem.render;
        newItem.render = ({ record, rowIndex: index }) => {
          // console.log(`render`, record.uniqueId, record.x_isExpandSub, record.swimStyle, record.distance);
          if (record.x_isExpandSub && record.swimStyle === 0 && record.distance === 0) {
            return '';
          }
          if (Definition.isRecoveryMode(record.mode) && record.distance === 0) {
            return EMPTY_TEXT;
          }
          return oldRender({ record, rowIndex: index });
        };
      }
    });
  }

  columns.uniqueId = {
    minWidth: 120,
    title: 'uniqueId',
    status: true,
    canSetStatus: false,
    render({ record: rowData, rowIndex: index }) {
      return `${rowData.uniqueId}`;
    }
  };

  return columns;
}
